import { render, staticRenderFns } from "./OfflineMessage.vue?vue&type=template&id=1795ac6a&scoped=true"
import script from "./OfflineMessage.vue?vue&type=script&lang=js"
export * from "./OfflineMessage.vue?vue&type=script&lang=js"
import style0 from "./OfflineMessage.vue?vue&type=style&index=0&id=1795ac6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795ac6a",
  null
  
)

export default component.exports